import { createSelector } from 'reselect';
import { ApplicationState } from '../../reducers';
import { CurrentImportState } from '../../reducers/importer/ImporterReducer';

const getImports = (state: ApplicationState) => state.importer.imports;
const getParentImports = (state: ApplicationState) => state.parent.parentImportLogs.imports;

export const getImportsWithNotification = createSelector(
  [getImports, getParentImports],
  (imports, parentImports) => [
    ...imports.filter(singleImport => singleImport.showNotification),
    ...parentImports.filter((singleImport: any) => singleImport.showNotification),
  ]
);

export const getRunningImports = createSelector(
  [getImports, getParentImports],
  (imports, parentImports) => [
    ...imports.filter(singleImport => singleImport.currentState === CurrentImportState.IMPORT),
    ...parentImports.filter(
      (singleImport: any) => singleImport.currentState === CurrentImportState.IMPORT
    ),
  ]
);
